import {
  type GenerateSearchSqlForStreamArgument,
  generateSearchSqlMustache,
  orderByLength,
  SEARCH_RESULT_LABEL_COLUMN_NAME,
  SEARCH_RESULT_VALUE_COLUMN_NAME,
} from './common.ts'

export function generateSearchSqlForSalesforceUserWithActive({ model }: GenerateSearchSqlForStreamArgument) {
  const nameProperty = model.properties.find((x) => x.meta === 'name')
  const labelField = nameProperty?.name ?? 'id'

  const userIsActiveProperty = model.properties.find((x) => x.name === 'is_active')

  if (nameProperty === undefined || userIsActiveProperty === undefined) {
    return
  }

  const searchSql = `SELECT
    id as ${SEARCH_RESULT_VALUE_COLUMN_NAME},
    "${labelField}" as ${SEARCH_RESULT_LABEL_COLUMN_NAME}
    FROM "${model.name}"
    WHERE ${generateSearchSqlMustache(`"${labelField}"`)}
    AND "${userIsActiveProperty.name}" = true
  `

  return {
    sql: orderByLength(searchSql, `"${labelField}"`),
    dependedPropertyNames: [{ streamName: model.name, propertyName: nameProperty.name }],
  }
}
